import { ChartType } from 'chart.js';
import React from 'react';

import { FaChartBar } from 'react-icons/fa';
import { FaChartPie } from 'react-icons/fa6';

interface ChartTypeToggleButtonProps {
    selectedChartType: ChartType;
    onSelectionHandler: (chartType: ChartType) => void;
}
const ChartTypeToggleButton: React.FC<ChartTypeToggleButtonProps> = (props) => {
    const { selectedChartType, onSelectionHandler } = props;

    return (
        <div className="tabs is-toggle is-medium is-justify-content-end">
            <ul>
                <li className={selectedChartType === 'pie' && 'is-active'} onClick={() => onSelectionHandler('pie')}>
                    <a>
                        <FaChartPie />
                    </a>
                </li>
                <li className={selectedChartType === 'bar' && 'is-active'} onClick={() => onSelectionHandler('bar')}>
                    <a>
                        <FaChartBar />
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default ChartTypeToggleButton;
